import { differenceInSeconds } from 'date-fns';
import { useEffect, useState } from 'react';

import { secondsToTime, getLocalTime } from 'containers/EmployeeTimeClock/shared/helper';
import { useTimeClockStore } from 'store/useTimeClockStore';

const useTimeElapsed = (pause: boolean) => {
  const [timeElapsed, setTimeElapsed] = useState<any>(0);

  const timeClockDetails: any = useTimeClockStore(state => state.timeClock);

  useEffect(() => {
    const clocked = timeClockDetails?.startLocal ? new Date(timeClockDetails?.startLocal) : null;

    if (!clocked) return;

    const currentTime = new Date();
    const localClockIn = getLocalTime(clocked, timeClockDetails?.userTimezone);
    let currentBreakTimeInSeconds = 0;
    if (timeClockDetails?.breaks.length > 0) {
      const localBreakTime = getLocalTime(
        new Date(timeClockDetails?.breaks[0]?.startLocal),
        timeClockDetails?.userTimezone
      );
      currentBreakTimeInSeconds = differenceInSeconds(currentTime, localBreakTime);
    }
    const breakTime = (timeClockDetails?.totalBreakInSeconds || 0) + currentBreakTimeInSeconds;
    const elapsedTime = differenceInSeconds(currentTime, localClockIn) - breakTime;
    setTimeElapsed(elapsedTime);

    const activeInterval = setInterval(() => {
      if (!pause) {
        setTimeElapsed((prev: any) => prev + 1);
      }
    }, 1000);

    return () => {
      clearInterval(activeInterval);
    };
  }, [pause, timeClockDetails]);

  return secondsToTime(timeElapsed, 'stopwatch');
};
export default useTimeElapsed;
